import React, { useEffect, useState } from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import bgResultWin from 'Static/Images/bg_result_win.png';
import bgResultWinMobile from 'Static/Images/bg_result_win_mobile.png';
import bgResultLose from 'Static/Images/bg_result_lose.png';
import bgResultLoseMobile from 'Static/Images/bg_result_lose_mobile.png';
import iPad from 'Static/Images/ipad_2026.png';
import airPods from 'Static/Images/airPods.png';
interface PopupProps {
  show: boolean;
  isSaymee?: string;
  prizePick?: { prizeName: string; price: string } | null;
  handleVisible: () => void;
}

export default function SpinResultPopup({
  show,
  isSaymee,
  prizePick,
  handleVisible,
}: PopupProps): JSX.Element {
  if (prizePick) console.log('Giải thưởng:', prizePick);
  // const modalClassName = 'bg-none';
  const [bgImage, setBgImage] = useState(bgResultWin);
  const [imgPrize, setImgPrize] = useState<string>('');
  useEffect(() => {
    const isMobile = window.innerWidth < 600;
    console.log('isMobile:', isMobile);
    if (prizePick) {
      // Trúng giải
      setBgImage(isMobile ? bgResultWinMobile : bgResultWin);
      if (prizePick.prizeName.includes('IPAD')) {
        setImgPrize(iPad);
      } else {
        setImgPrize(airPods);
      }
    } else {
      // Trượt giải
      setBgImage(isMobile ? bgResultLoseMobile : bgResultLose);
    }
  }, [prizePick, show]);

  const modalClassName = prizePick ? '' : 'bg-none bg-lose';

  return (
    <Modal
      show={show}
      size="lg"
      onHide={handleVisible}
      dialogClassName="modal-90w modal-spin-result"
      contentClassName={modalClassName}
      centered
    >
      {prizePick ? (
        <>
          <div>
            {/* <div style={{ position: 'absolute' }}>
              <Image src={bgImage} alt="Spin Result" className="image-bg-i" />
            </div> */}
            <div>
              <Modal.Header className="justify-content-center">
                <Modal.Title className="text-truncate d-flex justify-content-center m-auto">
                  <p className="title-header mb-0 text-header">Bạn đã trúng thưởng</p>
                  <Button variant="" className="bt-close-modal" onClick={handleVisible}></Button>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className=" spin-result text-center">
                  <div>
                    <Image src={imgPrize} alt="Spin Result" className="image-bg-i" />
                  </div>
                  <div className=" box-info-result text-center">
                    <p className="text-strong">{prizePick.prizeName}</p>
                    {/* <p>TRỊ GIÁ: {prizePick.price}</p> */}
                    <div className="mt-2">
                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed</p>
                      <p>Xin chúc mừng!!!</p>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </div>
          </div>
        </>
      ) : (
        <Modal.Body style={{ padding: 0 }}>
          <div className="wrapper-fail">
            {/* ← absolute để không đẩy content */}
            <Image
              src={bgImage}
              alt="Spin Result"
              className="image-bg-i"
              style={{
                borderRadius: '20px',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />

            {/* ← z-index để nổi lên trên ảnh */}
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className="d-flex justify-content-center spin-result text-center spin-result-lose">
                <div>
                  <div className="mt-3">
                    {!isSaymee ? (
                      <>
                        <p>Chúc bạn may mắn lần sau.</p>
                        <p>Cảm ơn bạn đã tham gia!</p>
                      </>
                    ) : (
                      <p>Cảm ơn Bồ đã tham gia. Hãy tiếp tục ủng hộ Saymee nhé!!!!</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-3 ">
                <Button variant="danger fs-18 rounded-10 text-bold" onClick={handleVisible}>
                  Đóng lại
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
}
